<mat-icon
    *ngFor="let estrella of estrellas; let idx = index"
    id="{{ rutContratista + 'estrellaId' + idx }}"
    (click)="countStar(estrella)"
    (mouseover)="addClass(estrella)"
    (mouseout)="removeClass(estrella)"
    [ngClass]="{
        'yellow-700-fg':
            (!seteable &&
                estrella <= evaluacion &&
                idx !== posicionAMedioPintar) ||
            (seteable && estrella <= evaluacion),
        'primary-A100-fg':
            (!seteable &&
                estrella > evaluacion &&
                idx !== posicionAMedioPintar) ||
            (seteable && estrella > evaluacion),
        'paint-half': !seteable && pintarMitad && idx === posicionAMedioPintar,
        'paint-one-third':
            !seteable && pintarUnTercio && idx === posicionAMedioPintar,
        'paint-two-third':
            !seteable && pintarDosTercios && idx === posicionAMedioPintar,
        'cursor-pointer': seteable
    }"
>
    star</mat-icon
>

<br />
<p class="text-left m-0">
    <small *ngIf="evaluacion >= 0">
        {{ evaluacion }}
        / {{ config.rating.cantidadEstrellas }}
    </small>
    <small *ngIf="evaluacion === -1"> Sin calificación </small>
</p>
